import {
    AuditOutlined
} from "@ant-design/icons";
import { Button } from "antd";
import { handleContabilizarFactura } from "../invoice.service";

export const PostInvoiceButton = ({ showButton, invoice, clients, setLoading }) => {
    if (!showButton && !invoice?.posted && !invoice.isDraft && invoice.No) {
        return null;
    }
    return (
        <Button
            icon={<AuditOutlined />}
            size="small"
            onClick={() => { handleContabilizarFactura(invoice, clients, setLoading) }}
            disabled={invoice?.pendingSync || invoice?.posted}
            title={invoice?.posted ? "La factura ya está contabilizada" : "Contabilizar factura"}
        />
    );
}
